export const SidebarMiniHeading = ({ children }: React.PropsWithChildren) => {
  return <h2 className="text-sm uppercase text-grey-700">{children}</h2>;
};

export default SidebarMiniHeading;
